export const container = `
  w-full h-full flex items-center justify-center flex-col
`;
